module.exports = __webpack_public_path__ + "static/media/ilocal-logo-secondary.fa80f3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/ilocal-logo-secondary.png
// module id = 13900
// module chunks = 0